
import {sha1} from 'object-hash';
import {hasWindow} from 'utils/functions';

type Order = {
	orderId: string
	customerId: string
	customerStatus?: 'New' | 'Existing'
	currencyCode: 'USD'
	orderPromoCode: string
	orderDiscount: number
	items: {
		subTotal: number
		category: string
		sku: string
		quantity: number
		name?: string
	}[]
};

// Define global object on window
declare global {
	interface Window {
		ire?(
			action: string,
			customer: {
				customerId: string,
				customerEmail: string,
			},
		): void;

		ire?(
			action: string,
			event: number,
			order: Order,
		): void;
	}
}

const impactOnlineSale = 50366;

export const impact = {
	identify: (user?: {id: string, email: string}) => {
		if (hasWindow() && window.ire) {
			window.ire('identify', {
				customerId: user?.id || '',
				customerEmail: user ? sha1(user.email) : '',
			});
		}
	},

	track: (order: Order) => {
		if (hasWindow() && window.ire) {
			window.ire('trackConversion', impactOnlineSale, order);
		}
	},
};
